import {
    advanceLogicFilters,
    advanceLogicFiltersSearchSSet,
    dataFilterValueProjectList,
    fetchDataProjectList,
    fetchSchemaProjectList,
    filterByLogicSearch,
} from './actions';

export const projectListActions = {
    fetchDataProjectList,
    fetchSchemaProjectList,
    dataFilterValueProjectList,
    filterByLogicSearch,
    advanceLogicFilters,
    advanceLogicFiltersSearchSSet,
};
